
import GwBlock from '~/patterns/atoms/block/block.vue';
import GwAvatar from '~/patterns/atoms/avatar/avatar.vue';

export default {
    components: {
        GwBlock,
        GwAvatar
    },
    props: {
        salesContact: {
            type: Object,
            default: () => { return {}; }
        }
    },
    computed: {
        emptyContact() {
            if (typeof this.salesContact === 'object') {
                return Object.keys(this.salesContact).length === 0;
            } else {
                return true;
            }
        }
    }
};
